// A shipment the customer booked in the portal shows no AWB / LR to the customer until Sendtoo staff have
// manifested it with the carrier (status moves on from "booked").
export const awaitingSendtoo = (s) => s?.booked_via === "CUSTOMER_PORTAL" && String(s?.status || "").toLowerCase() === "booked";
export const PENDING_TEXT = "Sendtoo is assigning";
